// filepath: cryptobag-com/src/components/FearGreedGauge.jsx
import React from 'react';

/**
 * FearGreedGauge Component
 * Displays the "Fear & Greed Index" in a gamified gauge.
 */
const FearGreedGauge = ({ loading, value, classification }) => {
  
  const GaugeSkeleton = () => (
    <div className="bg-gray-800/60 backdrop-blur-sm border border-gray-700/50 rounded-lg shadow-xl p-4 h-full flex flex-col items-center justify-center animate-pulse">
      <div className="h-4 bg-gray-700 rounded w-1/2 mb-4"></div>
      <div className="w-40 h-20 bg-gray-700 rounded-t-full mb-2"></div>
      <div className="h-8 bg-gray-700 rounded w-1/4 mb-2"></div>
      <div className="h-4 bg-gray-700 rounded w-1/3"></div>
    </div>
  );

  if (loading || value === undefined) {
    return <GaugeSkeleton />;
  }

  const rotation = (value / 100) * 180; // Map 0-100 to 0-180 degrees
  const color =
    value <= 25 ? 'text-red-500' :
    value <= 45 ? 'text-orange-500' :
    value <= 65 ? 'text-yellow-400' :
    'text-green-500';

  return (
    <div className="bg-gray-800/60 backdrop-blur-sm border border-gray-700/50 rounded-lg shadow-xl p-4 h-full flex flex-col items-center justify-center animate-fadeIn">
      <h3 className="text-sm font-medium text-gray-400 mb-1">Fear &amp; Greed Index</h3>
      <p className="text-[11px] text-gray-500 mb-2">Current market sentiment</p>
      <div className="relative w-40 h-20 overflow-hidden mb-2">
        {/* Gauge Background */}
        <div className="absolute top-0 left-0 w-40 h-40 rounded-full border-8 border-gray-700 border-b-transparent border-r-transparent transform -rotate-45" style={{ borderBottomColor: 'transparent', borderRightColor: 'transparent' }}></div>
        {/* Gauge Color Scale */}
        <div className="absolute top-0 left-0 w-40 h-40">
          <div className="absolute top-0 left-0 w-40 h-40 rounded-full border-8 border-transparent transform -rotate-45" style={{ clipPath: 'polygon(0% 0%, 50% 0%, 50% 50%, 0% 50%)', borderColor: '#ef4444' }}></div>
          <div className="absolute top-0 left-0 w-40 h-40 rounded-full border-8 border-transparent transform rotate-[-0deg]" style={{ clipPath: 'polygon(50% 0%, 100% 0%, 100% 50%, 50% 50%)', borderColor: '#f97316' }}></div>
          <div className="absolute top-0 left-0 w-40 h-40 rounded-full border-8 border-transparent transform rotate-[45deg]" style={{ clipPath: 'polygon(0% 50%, 50% 50%, 50% 100%, 0% 100%)', borderColor: '#eab308' }}></div>
          <div className="absolute top-0 left-0 w-40 h-40 rounded-full border-8 border-transparent transform rotate-[90deg]" style={{ clipPath: 'polygon(50% 50%, 100% 50%, 100% 100%, 50% 100%)', borderColor: '#22c55e' }}></div>
        </div>
        {/* Needle */}
        <div
          className="absolute bottom-0 left-1/2 w-1 h-20 bg-gray-200 transform -translate-x-1/2 transition-transform duration-1000"
          style={{ transform: `translateX(-50%) rotate(${rotation - 90}deg)`, transformOrigin: 'bottom center' }}
        >
          <div className="absolute -top-1 -left-1 w-3 h-3 bg-white rounded-full"></div>
        </div>
        <div className="absolute bottom-0 left-1/2 w-4 h-4 bg-gray-200 rounded-full transform -translate-x-1/2 translate-y-1/2"></div>
      </div>
      <div className={`text-3xl font-bold ${color}`}>{value}</div>
      <div className={`text-sm font-medium ${color}`}>{classification}</div>
    </div>
  );
};

export default FearGreedGauge;
